// libs
import { styled } from '@nykaa/ui-components';

export const Container = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

export const Reel = styled.div<{ isVertical: boolean; }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: transform 0.25s linear;
  will-change: transform;

  ${({ isVertical }) =>
    isVertical &&
    `
    flex-flow: column;
  `};
`;

export const Button = styled.button<{
  isHorizontal: boolean;
  isBottomNav?: boolean;
  isNext?: boolean;
}>`
  position: absolute;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;

  &[disabled] {
    opacity: 0.2;
  }

  ${({ isHorizontal, isNext = false }) => {
    if (isHorizontal) {
      return `
        top: 0;
        height: 100%;

        ${isNext ? 'right: 0;' : 'left: 0;'}
      `;
    } else {
      return `
        left: 0;
        width: 100%;

        ${isNext ? 'bottom: 0;' : 'top: 0;'}
      `;
    }
  }}

  ${({ isBottomNav = false }) =>
    isBottomNav &&
    `
    right: 0;
  `}
`;
